import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import DocumentSearch from '@/src/javascripts/document/DocumentSearch.vue'

$(document).on('turbo:load turbo:render', () => {
  const documentIndex = document.querySelector('#document-index')
  if (documentIndex && !documentIndex.__vue_app__) {
    const app = createApp({
      components: { BaseAlert, DocumentSearch }
    })

    app.mount(documentIndex)
  }
})
